// 统一管理新手引导 / 操作提示等本地持久化状态的 localStorage key
export const STORAGE_KEY = "userGuides_state";

function loadAll() {
  try {
    // 从 localStorage 读取所有引导状态，解析为对象
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    // 解析异常时直接返回空对象，避免影响正常逻辑
    return {};
  }
}

function saveAll(obj) {
  try {
    // 将所有引导状态整体写回 localStorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
  } catch (e) {
    // ignore quota errors etc.
  }
}

export function getGuideState(name) {
  // 获取指定引导的状态；默认返回 { hasSeen: false }
  const all = loadAll();
  return all[name] || { hasSeen: false };
}

export function markGuideSeen(name) {
  // 标记指定引导为“已查看”
  const all = loadAll();
  all[name] = {
    ...(all[name] || {}),
    hasSeen: true,
  };
  saveAll(all);
}

// 重置某个引导的状态，使其在下次进入时重新视为“未看过”
export function resetGuideState(name) {
  const all = loadAll();
  if (all[name]) {
    all[name] = {
      ...all[name],
      hasSeen: false,
    };
  } else {
    all[name] = {
      hasSeen: false,
    };
  }
  saveAll(all);
}
